// Local history of transactions created from this browser (no login required).
const KEY = "sl_local_tx_history";
const MAX = 20;

export function pushLocalTx(code) {
  if (!code) return;
  try {
    const list = getLocalTxCodes();
    const filtered = list.filter((c) => c !== code);
    filtered.unshift(code);
    localStorage.setItem(KEY, JSON.stringify(filtered.slice(0, MAX)));
  } catch (_e) { /* ignore */ }
  // Keep the push subscription in sync with the new tracked code (fire & forget)
  import("@/lib/push").then((m) => m.syncClientPush()).catch(() => null);
}

export function getLocalTxCodes() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return [];
    const arr = JSON.parse(raw);
    return Array.isArray(arr) ? arr : [];
  } catch (_e) {
    return [];
  }
}

export function removeLocalTx(code) {
  try {
    const list = getLocalTxCodes().filter((c) => c !== code);
    localStorage.setItem(KEY, JSON.stringify(list));
  } catch (_e) { /* ignore */ }
}

export function clearLocalTx() {
  localStorage.removeItem(KEY);
}
